export default "__VITE_ASSET__Ccdh3uK___"